import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ManifestApiAdapter } from '../adapters/ManifestApiAdapter';
import { useToast } from '@shared/hooks/use-toast';

export const useGenerateManifest = () => {
  const { toast } = useToast();
  const { t } = useTranslation('orderpreparationModule');
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ManifestApiAdapter(httpClient);

  return useMutation({
    mutationFn: (courierIntegrationId: number) =>
      adapter.generate({ courier_integration_id: courierIntegrationId }),
    onSuccess: () => {
      toast({
        title: t('manifest.toast.generateSuccess'),
        variant: 'default',
      });
    },
    onError: (error: any) => {
      toast({
        title: t('manifest.toast.generateError'),
        description: error?.response?.data?.message || error.message,
        variant: 'destructive',
      });
    },
  });
};
